import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { LanguagesService } from '../../../services/language.service';
import { BaseService } from '../../../services/base.service';
import { ValidationService } from 'src/app/services/validation.service';



@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
})


export class ExperienceComponent implements OnInit {
  @Input() form: FormGroup = null;
  myExperience: FormArray;
  public required = new Array<any> ();
  experienceList;

  constructor(public languagesService: LanguagesService,
    public baseService: BaseService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.form.addControl('myExperience', this.formBuilder.array([this.createMyExperience()]));
    this.myExperience = this.form.get('myExperience') as FormArray;
  }

  addMyExperienceItem() {
    this.myExperience.push(this.createMyExperience());
  }
  createMyExperience() {
    return this.formBuilder.group({
      workPlace: new FormControl('', []),
      startYear: new FormControl('', []),
      endYear: new FormControl('', []),
      job: new FormControl('', []),
      domain: new FormControl('', [])
    });
  }
  removeMyExperienceItem(i) {
    this.myExperience.removeAt(i);
    this.required[i] = false;
  }
  public change(i){
    this.required[i] = true;
    ValidationService.SetValidators(this.f2[i].controls.workPlace,[Validators.required,ValidationService.specialCharactesValidator]);
    ValidationService.SetValidators(this.f2[i].controls.startYear, [Validators.required,ValidationService.validStartEndYear, ValidationService.compareStartEndYear]);
    ValidationService.SetValidators(this.f2[i].controls.endYear, [Validators.required,ValidationService.validStartEndYear, ValidationService.compareStartEndYear]);
    ValidationService.SetValidators(this.f2[i].controls.job,[ValidationService.specialCharactesValidator]);
    ValidationService.SetValidators(this.f2[i].controls.domain);
  }
  public get f() {
    return this.form.controls;
  }
  public get f2() {
    return this.myExperience.controls as Array<FormGroup>;
  }
  onSubmit(){
    this.experienceList = new Array<any>();
    if (this.form.invalid) {
        this.form.markAllAsTouched();
        return false;
      }
    //אם יש יותר משורה אחת בדיקה שאין שורות חופפות!
    let j = 0, i = 0;
    for(i = 0; i< this.myExperience.length; i++)
    { 
      let error
      for( j = i; j< this.myExperience.length;j++)
      {
        if(i!=j){    
          error = ValidationService.compareExperience(this.f2[i].controls,this.f2[j].controls)
          if (error)
          {
            this.f2[j].controls.workPlace.setErrors(error) ;
            return
          }
        }   
      } 
      if (this.form.controls.myExperience.value[i].domain!="" &&(i == j)){
        let exper ={
          Uid:this.baseService.LoggedUser.MEZAHE_ZAFUY_INTERNET,
          Workplace:this.form.controls.myExperience.value[i].workPlace,
          StartYear:this.form.controls.myExperience.value[i].startYear,
          EndYear: this.form.controls.myExperience.value[i].endYear,
          JobTitle:this.form.controls.myExperience.value[i].job,
          KodEmpField:this.form.controls.myExperience.value[i].domain,
          TeurEmpField:this.baseService.ThumTaasuka.find(f=>f.KOD == [Number(this.form.controls.myExperience.value[i].domain)]).TEUR
        }
        this.experienceList.push(exper);
      }
    }      
    
  }
}




